import { IconProps } from "./IconProps";

export const LoginIcon24 = ({ className }: IconProps) => {
  return (
    <svg
      className={className}
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7 17.5556C7 17.5556 7 22 11.5 22H16C16 22 20.5 22 20.5 17.5556V6.44444C20.5 2 16.5625 2 16.5625 2H10.9375C7 2 7 5.88889 7 5.88889M2.5 12H14.875M14.875 12C14.875 10.8889 11.5 8.66667 11.5 8.66667M14.875 12C14.875 13.1111 11.5 15.3333 11.5 15.3333"
        stroke="white"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
    </svg>
  );
};
